export default __webpack_public_path__ + "static/media/Preguntas.f166502d.svg";